/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How match_value is interpreted.
 */
export const MatchType = {
  Exact: "exact",
  Regex: "regex",
  RuleId: "rule_id",
  Source: "source",
  EntityType: "entity_type",
} as const;
/**
 * How match_value is interpreted.
 */
export type MatchType = ClosedEnum<typeof MatchType>;

export type CreateRiskExclusionRequestBody = {
  /**
   * Whether the exclusion is active.
   */
  enabled?: boolean | undefined;
  /**
   * How match_value is interpreted.
   */
  matchType: MatchType;
  /**
   * The value matched against findings, interpreted per match_type.
   */
  matchValue: string;
  /**
   * Bind the exclusion to a single policy. Omit for a global (project-wide) exclusion.
   */
  riskPolicyId?: string | undefined;
  /**
   * Optional: only apply within this rule_id. Empty means any.
   */
  ruleIdFilter?: string | undefined;
  /**
   * Optional: only apply within this source. Empty means any.
   */
  sourceFilter?: string | undefined;
};

/** @internal */
export const MatchType$outboundSchema: z.ZodMiniEnum<typeof MatchType> = z.enum(
  MatchType,
);

/** @internal */
export type CreateRiskExclusionRequestBody$Outbound = {
  enabled: boolean;
  match_type: string;
  match_value: string;
  risk_policy_id?: string | undefined;
  rule_id_filter: string;
  source_filter: string;
};

/** @internal */
export const CreateRiskExclusionRequestBody$outboundSchema: z.ZodMiniType<
  CreateRiskExclusionRequestBody$Outbound,
  CreateRiskExclusionRequestBody
> = z.pipe(
  z.object({
    enabled: z._default(z.boolean(), true),
    matchType: MatchType$outboundSchema,
    matchValue: z.string(),
    riskPolicyId: z.optional(z.string()),
    ruleIdFilter: z._default(z.string(), ""),
    sourceFilter: z._default(z.string(), ""),
  }),
  z.transform((v) => {
    return remap$(v, {
      matchType: "match_type",
      matchValue: "match_value",
      riskPolicyId: "risk_policy_id",
      ruleIdFilter: "rule_id_filter",
      sourceFilter: "source_filter",
    });
  }),
);

export function createRiskExclusionRequestBodyToJSON(
  createRiskExclusionRequestBody: CreateRiskExclusionRequestBody,
): string {
  return JSON.stringify(
    CreateRiskExclusionRequestBody$outboundSchema.parse(
      createRiskExclusionRequestBody,
    ),
  );
}
